import get from './get'
import post from './post'
import patch from './patch'
import put from './put'
import del from './delete'
import pdf from './pdf'
import upload from './upload'

export default {
    get,
    post,
    patch,
    put,
    pdf,
    upload,
    'delete': del
}
